import React, { useState } from 'react';
import { Bell, UserPlus } from 'lucide-react';
import HiringScanner from './HiringScanner';
import NewCompanies from './NewCompanies';

const MODES = [
  { key: 'recent', label: 'Recent Postings', icon: Bell, Component: HiringScanner },
  { key: 'new', label: 'First-Time Companies', icon: UserPlus, Component: NewCompanies },
];

export default function SignalScannerView({ embedded = false, initialMode = 'recent' }) {
  const [mode, setMode] = useState(MODES.some(m => m.key === initialMode) ? initialMode : 'recent');
  const ActiveMode = MODES.find(m => m.key === mode)?.Component || HiringScanner;

  return (
    <div>
      <div className="flex items-center gap-2 bg-white border-b border-gray-200 px-6 py-3" data-testid="hiring-scanner-mode-toggle">
        {MODES.map(m => (
          <button
            key={m.key}
            onClick={() => setMode(m.key)}
            data-testid={`hiring-scanner-mode-${m.key}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full border transition-colors ${
              mode === m.key ? 'bg-[#0A1F44] text-white border-[#0A1F44]' : 'bg-white text-gray-500 border-gray-200 hover:border-[#0A1F44]/40'
            }`}
          >
            <m.icon className="h-3 w-3" /> {m.label}
          </button>
        ))}
      </div>
      <ActiveMode embedded={embedded} />
    </div>
  );
}
